import React, { useEffect, useRef } from "react";
import { Container } from "reactstrap";
import AOS from 'aos';
import 'aos/dist/aos.css';

function KebijakanPageHeader() {
  const pageHeader = useRef(null);

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 1000, // Animation duration
    });

    if (window.innerWidth > 991) {
      const updateScroll = () => {
        if (pageHeader.current) {
          let windowScrollTop = window.pageYOffset / 3;
          pageHeader.current.style.transform =
            "translate3d(0," + windowScrollTop + "px,0)";
        }
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  }, []); // Empty dependency array to ensure this runs only once

  return (
    <>
      <div className="page-header page-header-small">
        <div
          className="page-header-image"
          style={{
            backgroundImage: "url(" + require("assets/img/hero.png") + ")"
          }}
          ref={pageHeader}
        ></div>
        <div className="content-center">
          <Container>
            <h2
              className="title"
              data-aos="fade-left"
              dangerouslySetInnerHTML={{ __html : "KEBIJAKAN PRIVASI" }}
            ></h2>
            <div className="underline" data-aos="fade-right" data-aos-delay="300"></div>
            <div className="text-center">
              {/* Add more content here if needed */}
            </div>
          </Container>
        </div>
      </div>
      <style jsx>{`
        .underline {
          width: 200px;
          height: 4px;
          background-color: white;
          margin: 10px auto;
          transition: all 1.5s ease; // Smooth transition for underline
        }
      `}</style>
    </>
  );
}

export default KebijakanPageHeader;
